<template>
  <div>
    <button @click="exec">Exec</button><br /><br />
    <Meal
      :style="{ width: `300px` }"
      :meal="{
        title: 'meal title',
        ingredients: [
          'test',
          'gresferd',
          'test',
          'test',
          'gresferdfe',
          'test',
          'gr',
          'test',
        ],
      }"
      :clickable="false"
      :updatable="false"
    />
  </div>
</template>

<script>
// import moment from 'moment';
// import * as fb from '../../../firebase';
import Meal from '../../../components/Meals/Meal.vue';

export default {
  components: {
    Meal,
  },
  methods: {
    exec() {},
  },
};
</script>
